<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :model="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="trade_from"
                          label="平台">
              <el-select clearable
                         v-model="form.trade_from"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in tradefrom"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="profession"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label-width
                          prop="sku"
                          label="SKU">
              <el-input v-model="form.sku"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="product_title"
                          label="商品名">
              <el-input v-model="form.product_title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="original_tid"
                          label="平台订单号">
              <el-input v-model="form.original_tid"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="buyer_nick"
                          label="买家ID">
              <el-input v-model="form.buyer_nick"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="searchAreaStatus">
          <el-col :span="8">
            <el-form-item label-width
                          prop="pay_time"
                          label="付款时间">
              <!-- <el-input v-model="form.pay_time"></el-input> -->
              <el-date-picker v-model="form.pay_time"
                              type="datetimerange"
                              style="width:100%"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label-width="150px"
                          prop="count_buyer"
                          label="客户维度购买次数">
              <number-range v-model="form.count_buyer"></number-range>
              <!-- <el-input v-model="form.count_buyer"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label-width="150px"
                          prop="count_product"
                          label="产品维度购买次数">
              <!-- <el-input v-model="form.count_product"></el-input> -->
              <number-range v-model="form.count_product"></number-range>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="actionLineWithoutImport">
        <el-button type="primary"
                   @click="handleComput">重新计算</el-button>

        <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开"}}</el-button>
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              :data="tableData"
              border>
      <el-table-column prop="count_buyer"
                       align="center"
                       header-align="center"
                       label="客户维度购买次数"></el-table-column>
      <el-table-column prop="count_product"
                       align="center"
                       header-align="center"
                       label="产品维度购买次数"></el-table-column>
      <el-table-column prop="original_tid"
                       align="center"
                       header-align="center"
                       label="平台订单号"></el-table-column>
      <el-table-column prop="buyer_nick"
                       align="center"
                       header-align="center"
                       label="买家ID"></el-table-column>
      <el-table-column prop="sku"
                       align="center"
                       header-align="center"
                       label="SKU"></el-table-column>
      <el-table-column prop="product_title"
                       align="center"
                       header-align="center"
                       label="商品名"></el-table-column>
      <el-table-column prop="payment_product"
                       align="center"
                       header-align="center"
                       label="单个商品实付金额"></el-table-column>
      <el-table-column prop="discount"
                       align="center"
                       header-align="center"
                       label="折扣率"></el-table-column>
      <el-table-column prop="pay_time"
                       align="center"
                       header-align="center"
                       label="付款时间"></el-table-column>
      <el-table-column prop="profession"
                       align="center"
                       header-align="center"
                       label="行业"></el-table-column>
      <el-table-column prop="business"
                       align="center"
                       header-align="center"
                       label="商家"></el-table-column>
      <el-table-column prop="store"
                       align="center"
                       header-align="center"
                       label="店铺"></el-table-column>
    </el-table>

    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
    <compute-dialog ref="refComputeDialog"></compute-dialog>
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
import computeDialog from './dialog.vue'
import { getplatlists, getptnlists, getshoplists } from '@/common/mixins/select'
export default {
  mixins: [ActionLine, SearchMixin, getplatlists, getptnlists, getshoplists],
  components: { computeDialog },
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {
    // 覆盖 searchMixin 里的定义
    getTableData() {},
    handleSearch() {
      if (!this._collectQuery()) {
        return
      }
      if (!this.form.store) {
        this.$message.error('请先选择店铺')
        return
      }
      this.getData()
      console.log('this.queryPrdlists', this.queryPrdlists)
    },
    clearSearch() {
      this.form = {
        business: '', // 商家
        store: '', // 店铺
      }
    },

    handleExport() {
      if (!this.form.store) {
        this.$message.error('请先选择店铺')
        return
      }
      this.$refs.refExportDialog.show()
    },
    // 重新计算
    handleComput() {
      this.$refs.refComputeDialog.show()
    },
    async getData() {
      this.loading = true
      let { data, err } = await this.axiosApi(
        this.Desc.list_api,
        this.queryPrdlists
      )
      this.loading = false

      if (data && data.data.meta.status === 200) {
        this.tableData = data.data.data.data
        this.total = parseInt(data.data.data.total)
      } else {
        dealReturn(data, err)
      }
    },
  },
  watch: {
    pageNumOrPageSizeChange(newVal, oldVal) {
      if (this.searchAreaStatus) {
        this.searchAreaStatus = false // xx
      }
      this.handleSearch()
    },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/statistics/buy-again/index.vue